import React from 'react';
import { ComponentProps } from '../..';
import Initial from './Variants/Initial';
import useDHFlag from '../../../../hooks/useDHFlag';
import MultiApps from './Variants/MultiApps';

const Large: React.FC<Omit<ComponentProps, 'size'>> = props => {
  const multiAppFlag = useDHFlag('multi-app-trigger');

  if (multiAppFlag) {
    return <MultiApps {...props} />;
  }
  return <Initial {...props} />;
};

export default Large;
